export enum ExcelExporterVariableType {
Generic,
Currency,
Days,
Hours,
Rate,
}
